import { CSSProperties } from "react"

export enum Action {
  add = 'add',
  delete = 'delete',
  preview = 'preview',
  clear = 'clear',
  subscribePreview = 'subscribe-preview',
  replace = 'replace'
}
export interface SendModelProps {
  hbjson?: object
  defaultAction?: Action
  defaultKey?: string
  optionsConfig?: { [index in Action]: boolean }
  onOverlayHeightChange?: (height: number) => any
}
